import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import { withToggle } from "../withToggle";

const TotalMembers = ({ qa }) => {
  const {
    totalMembersNumber,
    totalMembersNumberLink,
    totalMembersPercentChange,
    tooltip,
    prevTotalMembersNumber,
    prevTotalMembersNumberLink
  } = useSelector((state) => state.membershipUnits.membershipUnits.totalActive);

  const isPayingMembers = useSelector(
    (state) => state.membershipUnits.membershipUnits.isPayingMembers
  );
  const title = isPayingMembers ? "Paying Members" : "Total Active Members";

  return (
    <>
      <div className="content__el">
        <DataDisplay
          label={title}
          type="number"
          value={totalMembersNumber}
          url={totalMembersNumberLink}
          disableAnimation={qa}
          toolTipContent={tooltip}
          toolTipId="membershipUnitTotalActiveMembers"
          changeProps={{
            changeValue: totalMembersPercentChange,
            toolTip: "Percentage change from previous month",
            showBorder: true
          }}
        />
      </div>
      <PreviousTotalMembers
        title={"Previous " + title}
        commonProps={{
          toolTipContent: `Previous ${tooltip}`,
          toolTipId: "membershipUnitPreviousTotalActiveMembers"
        }}
        dataPointProps={{
          type: "number",
          value: prevTotalMembersNumber,
          url: prevTotalMembersNumberLink,
          disableAnimation: qa
        }}
      />
    </>
  );
};

const PreviousTotalMembers = withToggle(DataDisplay);

export default TotalMembers;
